import { go_to_site } from "./utils";

const shop_links = {
    "meesho" : "https://www.meesho.com/ShoppyHobbies?ms=2"
}

function go_to_shop(shop_name) {
    let shop_link = shop_links[shop_name] || undefined;
    
    if (!shop_link) {
        console.error("Shop link not found.");
        return;
    }

    go_to_site(shop_link, true);
}

export {
    go_to_shop
}